import { ChangeDetectorRef, Component, forwardRef, Inject } from '@angular/core';
import { LoadingController, NavController, NavParams, Platform, ToastController } from 'ionic-angular';
import { EbsWebService } from "../../services/ebsWebService";
import { EbsComponentService } from "../../services/ebsComponentService";
// import * as $ from 'jquery'; // unused???

import { Vibration } from '@ionic-native/vibration';
import { BarcodeFunction } from '../../functions/barcode';
import { Events } from 'ionic-angular';



@Component({
	selector: 'page-scanner-sort',
	templateUrl: 'scanner-sort.html',
})

export class ScannerSortPage {
	title: string;
	contentTitle: string = "";
	result: any;
	private scan_url: string = "";
	private scan_params: string = "";
	private finish_url: string = "";
	private finish_params: string = "";
	private dataUrl: string = "";
	public showTestButtons: boolean = true;
	private test_code: string;
	private finish_viewTypeAction: string = "";
	orders: any = {};
	showPrevBtn: boolean = false;
	showNextBtn: boolean = false;

	public constructor(
		public navCtrl: NavController,
		public navParams: NavParams,
		private vibration: Vibration,
		private barcodeFunction: BarcodeFunction,
		public events: Events,
		private platform: Platform,
		private _ebsWebService: EbsWebService, @Inject(forwardRef(() => EbsComponentService)) private _ebsComponentService: EbsComponentService,
		public loadingCtrl: LoadingController,
		private cdRef: ChangeDetectorRef,
		public toastController: ToastController) {
		this.dataUrl = navParams.get('actionURL');
		//events.publish("reloadMenu");
	}

	sendCodeToWebservice(code) {

		let scan_post_params = this.scan_params + code;


		let postPayloadObject = this._ebsWebService.buildPostPayloadObjectFromGetParameters(scan_post_params);
		console.log('scan params', scan_post_params);
		console.log('postPayloadObject', postPayloadObject);
		let sub = this._ebsWebService.postData(this.scan_url, postPayloadObject);
		sub.subscribe(res => {
			console.log(res);
			console.log("scanning");
			if (res != null && res.Caption != "BARCODE_NOT_FOUND" && res.Caption != "BARCODE_ALREADY_EXISTS") {
				if (res.ListItemNavigation != "" && res.ListItemNavigation != null) {
					this.getGroupedArticlesForScanning(res.ListItemNavigation);
					this.getScannerActions(res.ListItemAction);
					//Todo Scroll to Scanned articel
				} else { // Push Artikel Suche
					this.openPage(res.ListItemAction[0]);
				}
				if (res.Dynamic && typeof res.Dynamic.AutomaticAction != "undefined" && res.Dynamic.AutomaticAction != null && res.Dynamic.AutomaticAction == "True") {
					this.next();
				}
			} else if (res.Caption == "BARCODE_NOT_FOUND") {
				const toast = this.toastController.create({
					message: 'Barcode nicht gefunden!',
					duration: 2200,
					cssClass: "toast-scan-error"
				});
				toast.present();
			} else if (res.Caption == 'BARCODE_ALREADY_EXISTS') {
				const toast = this.toastController.create({
					message: 'Barcode wurde bereits eingescannt!',
					duration: 3000,
					cssClass: 'toast-scan-error'
				});
				toast.present();
			} else {
				console.log("return");
				return;
			}
			this.cdRef.detectChanges();
			this.checkScannedItems();
		});
	}

	sendTestCode() {
		console.log(this.test_code);
		if (this.test_code) {
			this.sendCodeToWebservice(this.test_code);
		}
	}

	next() {
		let item = { ActionUrl: this.finish_url, PostParameters: this.finish_params, title: "", ViewTypeAction: this.finish_viewTypeAction };
		console.log(item);
		this.openPage(item);
	}

	ionViewWillEnter() {
		this.platform.ready().then(() => {

			if (this.platform.is('android') || this.platform.is('mobileweb')) {
				this.showTestButtons = false;
			}

			this.events.subscribe('data:scan', (scanData, time) => {
				let scannedData = scanData.extras["com.symbol.datawedge.data_string"];
				console.log("events");
				this.sendCodeToWebservice(scannedData);
				this.vibration.vibrate([100]);
				this.cdRef.detectChanges();
				this.checkScannedItems();
			});

			if (this.dataUrl != "") {
				this.loadRawArticleData(this.dataUrl);
			}
		});
	}

	ionViewWillLeave() {
		console.log("leave");
		this.events.unsubscribe('data:scan', null);
	}

	checkScannedItems() {
		if (Object.keys(this.orders).length) {
			this.showNextBtn = true;
		} else {
			this.showNextBtn = false;
		}

		if (this.navCtrl.length() == 1) {
			this.showPrevBtn = false;
		}
	}

	loadRawArticleData(dataUrl) {
		let loading = this.loadingCtrl.create({
			content: 'Bitte warten...'
		});
		loading.present();
		let postPayloadObject = this._ebsWebService.buildPostPayloadObjectFromGetParameters(this.navParams.get('postParams'));
		this._ebsWebService.postData(dataUrl, postPayloadObject).subscribe(res => {
			if (typeof res != "undefined" && res != null) {
				this.getGroupedArticlesForScanning(res.ListItemNavigation);
				this.getScannerActions(res.ListItemAction);

				if (res.Dynamic != null && typeof res.Dynamic.CustomMainTitle != "undefined" && res.Dynamic.CustomMainTitle != null) {
					this.title = res.Dynamic.CustomMainTitle;
				} else {
					this.title = res.MainTitle;
				}

				if (res.Dynamic != null) {
					if (typeof res.Dynamic.ContentTitle != "undefined" && res.Dynamic.ContentTitle != null) {
						this.contentTitle = res.Dynamic.ContentTitle;
					}

					if (res.Dynamic.PrevBtn == "True" && res.Dynamic.PrevBtn != null) {
						this.showPrevBtn = true;
					}
				}

				this._ebsWebService.setBrowserTabTitle(res.MainTitle);
				this.cdRef.detectChanges();
				loading.dismiss();
			}
			this.checkScannedItems();
		});
	}

	getScannerActions(actions) {
		actions.forEach(action => {
			if (action.ActionName == "View") {
				this.scan_url = action.ActionUrl;
				this.scan_params = action.PostParameters;
			}
			if (action.ActionName == "Finish") {
				this.finish_url = action.ActionUrl;
				this.finish_params = action.PostParameters;
				this.finish_viewTypeAction = action.ViewTypeAction;
			}
		})
	}

	getGroupedArticlesForScanning(articles) {
		this.orders = {};
		articles.forEach((article) => {
			let articlePrepared = { title: "", code: "", content: "", caption: "", actionUrl: "", actionParams: "", ViewTypeAction: "" };
			articlePrepared.actionUrl = article.Action;
			articlePrepared.actionParams = article.PostParameters;
			articlePrepared.ViewTypeAction = article.ViewTypeAction;
			article.ListItemContent.forEach((field) => {
				switch (field.FieldName) {
					case "scan-title":
						articlePrepared.title = field.DisplayText;
						break;
					case "scan-code":
						articlePrepared.code = field.DisplayText;
						break;
					case "scan-content":
						articlePrepared.content = field.DisplayText;
						break;
					case "scan-caption":
						articlePrepared.caption = field.DisplayText;
						break;
					default:
						articlePrepared.caption = field.DisplayText;
						break;
				}
			});

			console.log(article);
			if (this.orders[article.GroupDisplayName] === undefined) {
				let orderArray = [];
				orderArray.push(articlePrepared);
				this.orders[article.GroupDisplayName] = orderArray;
			} else {
				this.orders[article.GroupDisplayName].push(articlePrepared);
			}
		});
		this.checkScannedItems();
	}

	public fabDown() {
		this.barcodeFunction.sendCommand("com.symbol.datawedge.api.SOFT_SCAN_TRIGGER", "START_SCANNING");
	}

	public fabUp() {
		this.barcodeFunction.sendCommand("com.symbol.datawedge.api.SOFT_SCAN_TRIGGER", "STOP_SCANNING");
	}

	openPage(item) {
		if (typeof item.ActionUrl != "undefined" && item.ActionUrl != "" && item.ActionUrl != null) {
			let navParams = {
				title: item.DisplayName,
				actionURL: item.ActionUrl,
				postParams: item.PostParameters
			};
			this._ebsComponentService.navigationController(item, navParams, this.navCtrl);
		} else {
			return;
		}
	}

}



// WEBPACK FOOTER //
// ./src/pages/scanner-sort/scanner-sort.ts